export const options = [
  {
    label: 'book',
    prop: 'book'
  },
  {
    label: 'priview',
    prop: 'priview'
  },
  {
    label: 'standard',
    prop: 'standard'
  },
  {
    label: 'highquality',
    prop: 'highquality'
  },
  {
    label: 'print',
    prop: 'print'
  },
  {
    label: 'wxshow',
    prop: 'wxshow'
  },
  {
    label: 'action',
    prop: 'action'
  }
]
